export const SERVER_ERROR = "OOPS! Something went wrong. Please try again later.";
export const CAPTCHA_ERROR = "Please verify that you are not a robot by filing the captcha. If you are unable to see one please try reloading the page.";